module.exports = __webpack_public_path__ + "img/n_img1.1fd833ed.png";